module.exports = __webpack_public_path__ + "img/responsive hospitium-11.458bd6dc.jpg";